import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_MOVIMIENTOS_DIARIOS_EXP } from '../../../../config/tables'

export default function MovimientosDiariosExportadorView () {
  return (
    <MuiTable id={TABLA_MOVIMIENTOS_DIARIOS_EXP} />
  )
}
